import styled from 'styled-components';
import { Tabs } from 'antd';

const TabPane = Tabs.TabPane;
export const CustomTab = styled(TabPane)``;
